import { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import add from '@iconify/icons-ic/add';
import { AiFillSetting } from 'react-icons/ai';
import { HiTemplate } from 'react-icons/hi';
import { RiSaveFill } from 'react-icons/ri';
import CloseIcon from '@mui/icons-material/Close';
// material
import {
  Box,
  Tooltip,
  IconButton,
  Typography,
  InputAdornment,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import useJourneySelector from '../../store/Slice/Journey/JourneySelector';
import { getTemplateDropdown } from '../../store/Slice/Journey/JourneySlice';
import { RootStyle, SearchStyle } from '../Global/Styling';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import JourneyService from '../services/JourneyService';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

const { LoadTemplateDropDown } = JourneyService;
// ----------------------------------------------------------------------

export default function JourneyToolbar({
  filterName,
  onFilterName,
  parent,
  selected,
  setSelected,
  templateName,
  setTemplateName,
  handleSaveTemplate,
  errorMessage,
  setErrorMessage,
  saveTemplate,
  setSaveTemplate
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [cardName, setCardName] = useState(false);
  const [showHide, setShowHide] = useState(' ');
  const [selectTemplate, setSelectTemplate] = useState(' ');
  const [userType, setUserType] = useState('New Template');

  const { JourneyTemplateNameListDrop } = useJourneySelector();
  const { LoginData } = useLoginSelector();

  const handleShowHide = (event) => {
    const getUserType = event.target.value;
    setShowHide(getUserType);
  };

  const fireDropdownApi = async (e) => {
    if (LoginData !== null) {
      dispatch(getTemplateDropdown());
    }
  };

  return (
    <>
      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1'
        }}
      >
        <Box>
          <Tooltip title="Add" placement="top" arrow>
            <IconButton
              className="squareIconButton"
              onClick={(e) => {
                localStorage.removeItem('viewJourneyId');
                localStorage.removeItem('cardTypeListAll');
                localStorage.removeItem('journeyDetailsId');
                localStorage.removeItem('fldListAll');
                localStorage.removeItem('journeybyIdData');
                setCardName(true);
              }}
            >
              <Icon icon={add} width={18} />
            </IconButton>
          </Tooltip>
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Configure" placement="top" arrow>
            <IconButton
              className="squareIconButton"
              onClick={(e) => navigate(`/${parent}/configure`)}
            >
              <AiFillSetting size={18} />
            </IconButton>
          </Tooltip>
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Template" placement="top" arrow>
            <IconButton
              className="squareIconButton"
              onClick={(e) => navigate(`/${parent}/template`)}
            >
              <HiTemplate size={18} />
            </IconButton>
          </Tooltip>
          &nbsp;&nbsp;&nbsp;
          <Tooltip
            title="Save as Template"
            placement="top"
            arrow
            onClick={(e) => setSaveTemplate(true)}
          >
            <IconButton
              className="squareIconButton"
              classes={{ disabled: 'disabledBtn' }}
              disabled={selected && selected.length < 1}
            >
              <RiSaveFill size={18} />
            </IconButton>
          </Tooltip>
        </Box>
        <Box>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Journey"
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
        </Box>
      </RootStyle>
      {/* pop up start */}
      <Dialog fullWidth className="PopupBox" open={cardName} onClose={(e) => setCardName(false)}>
        <DialogTitle className="popupTitle">
          <Typography variant="h6">Add Journey</Typography>
          <IconButton
            onClick={(e) => {
              setCardName(false);
              setShowHide(' ');
              setSelectTemplate(' ');
              setUserType('New Template');
            }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={userType}
            onChange={(e) => {
              handleShowHide(e);
              setUserType(e.target.value);
              if (e.target.value === 'Load Template') {
                fireDropdownApi(e);
              }
            }}
          >
            <FormControlLabel value="New Template" control={<Radio />} label="New Template" />
            <FormControlLabel value="Load Template" control={<Radio />} label="Load Template" />
          </RadioGroup>
          {showHide === 'Load Template' && (
            <Box mt={2}>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectTemplate}`
                }}
                value={selectTemplate}
                onChange={(e) => setSelectTemplate(e.target.value)}
                MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
              >
                <MenuItem value=" ">Select Template</MenuItem>
                {JourneyTemplateNameListDrop?.length > 0 &&
                  JourneyTemplateNameListDrop?.map((item, index) => (
                    <MenuItem key={item?.value} value={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => {
              setCardName(false);
              navigate(`/${parent}/add`, {
                state: {
                  pageType: 'Add'
                }
              });
            }}
            variant="contained"
            className="mainBtn"
          >
            Next
          </Button>
        </DialogActions>
      </Dialog>
      {/* pop up end */}

      {/* pop up start */}
      <Dialog
        fullWidth
        className="PopupBox"
        open={saveTemplate}
        onClose={(e) => setSaveTemplate(false)}
      >
        <DialogTitle className="popupTitle">
          <Typography variant="h6">Set Template Name</Typography>
          <IconButton
            onClick={(e) => {
              setTemplateName('');
              setSaveTemplate(false);
            }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="h6" className="formLabel">
            Template Name
          </Typography>
          <TextField
            id="outlined-required"
            fullWidth
            inputProps={{
              className: 'textInput'
            }}
            helperText={errorMessage}
            placeholder="Type Template Name"
            value={templateName}
            onChange={(e) => {
              setErrorMessage('');
              setTemplateName(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => handleSaveTemplate(e, selected, setSelected)}
            variant="contained"
            className="mainBtn"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/* pop up end */}
    </>
  );
}
